// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","logo":"Footer_logo__+JiYo","roadmap":"Footer_roadmap__A3yc2","social":"Footer_social__iB1oi","socialimg":"Footer_socialimg__pSqwc"};